import { render, staticRenderFns } from "./ProjectUpsertForm.vue?vue&type=template&id=0fb1c43e&"
import script from "./ProjectUpsertForm.vue?vue&type=script&lang=js&"
export * from "./ProjectUpsertForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUpsertForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports